import { Brand } from 'models/inventory/interfaces/brand.interface';
import { Role } from 'models/ozonio/interfaces/ozonio.interface';
import { Provider } from 'models/provider/interfaces/provider.interface';

const clearBrands = () => {
	localStorage.removeItem('brands');
};
const getBrandsModels: () => Brand[] | null = () => {
	const brands = localStorage.getItem('brands');
	if (brands) {
		const parsed = JSON.parse(brands);
		if (parsed.timeout > Date.now()) {
			if (Array.isArray(parsed.data) && parsed.data.length > 0)
				return parsed.data;
			// If cache is corrupt/empty, force a refetch.
			clearBrands();
		}
		clearBrands();
	}
	return null;
};

const setBrands = (brands: Brand[]) => {
	const timeout = new Date();
	timeout.setDate(timeout.getDate() + 1);
	localStorage.setItem(
		'brands',
		JSON.stringify({ timeout: timeout.getTime(), data: brands }),
	);
};

const clearRoles = () => {
	localStorage.removeItem('roles');
};
const getRoles: () => Role[] | null = () => {
	const roles = localStorage.getItem('roles');
	if (roles) {
		const parsed = JSON.parse(roles);
		if (parsed.timeout > Date.now()) return parsed.data;
		clearRoles();
	}
	return null;
};

const setRoles = (roles: Role[]) => {
	const timeout = new Date();
	timeout.setDate(timeout.getDate() + 1);
	localStorage.setItem(
		'roles',
		JSON.stringify({ timeout: timeout.getTime(), data: roles }),
	);
};

const clearProviders = () => {
	localStorage.removeItem('providers');
};
const getProvidersCache: () => Provider[] | null = () => {
	const providers = localStorage.getItem('providers');
	if (providers) {
		const parsed = JSON.parse(providers);
		if (parsed.timeout > Date.now()) {
			if (Array.isArray(parsed.data) && parsed.data.length > 0)
				return parsed.data;
			clearProviders();
		}
		clearProviders();
	}
	return null;
};

const setProviders = (providers: Provider[]) => {
	const timeout = new Date();
	timeout.setDate(timeout.getDate() + 1);
	localStorage.setItem(
		'providers',
		JSON.stringify({ timeout: timeout.getTime(), data: providers }),
	);
};

export {
	getBrandsModels,
	setBrands,
	clearBrands,
	getRoles,
	setRoles,
	clearRoles,
	getProvidersCache,
	setProviders,
	clearProviders,
};
